const moduleName = 'i18n';

const SET_LOCALE = `${moduleName}/SET_LOCALE`;

export default {
  SET_LOCALE,
};
